<div class="router-bar">
  <div class="materials-order-route doughnuts-route" [ngClass]="{'current-route': router.url === '/reports/charts'}">
    <button mat-button [routerLink]="['/reports/charts']">Company Sales</button>
  </div>
  <div class="materials-order-route doughnuts-route" [ngClass]="{'current-route': router.url === '/reports/projects'}">
    <button mat-button [routerLink]="['/reports/projects']">Project Report</button>
  </div>
  <div class="materials-order-route complexity-route" [ngClass]="{'current-route':
    router.url === '/reports/complexity/projects' || router.url === '/reports/complexity/cabinets'}">
    <button mat-button [routerLink]="['/reports/complexity']">Projects Complexity</button>
  </div>
  <div class="materials-order-route project-cost-route" [ngClass]="{'current-route':
    router.url === '/reports/project-cost'}">
    <button mat-button [routerLink]="['/reports/project-cost']">Project Cost</button>
  </div>
</div>

<router-outlet></router-outlet>
